// Accesibilidad del menú móvil (partials/header/header_main.sbn).
// Abrir y cerrar sigue en manos de assets/js/main.js (clase mobile-menu-visible en <body>);
// aquí se sincroniza aria-expanded, se lleva el foco al panel, se retiene dentro mientras
// está abierto, se cierra con Escape y se devuelve el foco al botón que lo abrió.

const SELECTOR_ENFOCABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export const initMenuMovil = (root?: HTMLElement) => {
  if (!root) return;

  const panel = root.querySelector<HTMLElement>('.menu-box') ?? root;
  const botonCerrar = root.querySelector<HTMLElement>('.close-btn');
  const botonesAbrir = Array.from(document.querySelectorAll<HTMLElement>('.mobile-nav-toggler'));
  let origen: HTMLElement | null = null;
  let estabaAbierto = false;

  const estaAbierto = () => document.body.classList.contains('mobile-menu-visible');

  const enfocables = () =>
    Array.from(panel.querySelectorAll<HTMLElement>(SELECTOR_ENFOCABLE)).filter(
      (el) => el.offsetParent !== null || el === document.activeElement,
    );

  botonesAbrir.forEach((boton) => boton.addEventListener('click', () => (origen = boton)));

  const sincronizar = () => {
    const abierto = estaAbierto();
    if (abierto === estabaAbierto) return;
    estabaAbierto = abierto;

    botonesAbrir.forEach((boton) => boton.setAttribute('aria-expanded', String(abierto)));

    if (abierto) {
      window.setTimeout(() => (botonCerrar ?? enfocables()[0])?.focus(), 50);
    } else if (origen) {
      origen.focus();
      origen = null;
    }
  };

  new MutationObserver(sincronizar).observe(document.body, { attributes: true, attributeFilter: ['class'] });

  document.addEventListener('keydown', (evento) => {
    if (!estaAbierto()) return;

    if (evento.key === 'Escape') {
      document.body.classList.remove('mobile-menu-visible');
      return;
    }

    if (evento.key !== 'Tab') return;
    const lista = enfocables();
    if (lista.length === 0) return;
    const primero = lista[0];
    const ultimo = lista[lista.length - 1];
    const activo = document.activeElement as HTMLElement | null;

    if (!activo || !panel.contains(activo)) {
      evento.preventDefault();
      primero.focus();
    } else if (evento.shiftKey && activo === primero) {
      evento.preventDefault();
      ultimo.focus();
    } else if (!evento.shiftKey && activo === ultimo) {
      evento.preventDefault();
      primero.focus();
    }
  });
};
